module.exports = __webpack_public_path__ + "img/i_mytown_s.94832c66.svg";